import React from 'react';
import { combineStrings } from '../../../Shared/utils/string';
import { AddressType } from '@clearcover/core-app-types';

type AddressProps = {
  address: AddressType;
  className?: string;
  testId?: string;
};

export const MultilineAddress = ({
  address,
  className,
  testId,
}: AddressProps) => {
  const { address1, address2, city, state, zip } = address;

  return (
    <div className={className} data-testid={testId}>
      {address1}
      {address1 && address2 && <br />}
      {address2}
      {(address1 || address2) && (city || state || zip) && <br />}
      {(city || state || zip) &&
        combineStrings([
          city ? `${`${city}${state || zip ? ',' : ''}`}` : '',
          state ? state.toUpperCase() : '',
          zip,
        ])}
    </div>
  );
};
